import { render, staticRenderFns } from "./PickedInsectsDraw.vue?vue&type=template&id=29f3a04f&"
import script from "./PickedInsectsDraw.vue?vue&type=script&lang=js&"
export * from "./PickedInsectsDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PickedInsectsDraw.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f3a04f')) {
      api.createRecord('29f3a04f', component.options)
    } else {
      api.reload('29f3a04f', component.options)
    }
    module.hot.accept("./PickedInsectsDraw.vue?vue&type=template&id=29f3a04f&", function () {
      api.rerender('29f3a04f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PickedInsectsDraw.vue"
export default component.exports